import React from "react";

export const FormLabel: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = "",
}) => {
  return (
    <label className={`block text-sm font-semibold text-slate-700 mb-2 ${className}`}>
      {children}
    </label>
  );
};
